/* eslint-disable consistent-return */
import {
	isSignInWithEmailLink,
	signInWithEmailLink,
	AuthErrorCodes,
	getAuth
} from 'firebase/auth'
import { FirebaseError } from 'firebase/app'

import { SIGN_IN_WITH_EMAIL_LOCAL_KEY } from './types'

export const signInWithLinkConfirmation = async (
	email: string = window.localStorage.getItem(SIGN_IN_WITH_EMAIL_LOCAL_KEY)!
) => {
	if (!email) return

	const auth = getAuth()

	if (isSignInWithEmailLink(auth, window.location.href)) {
		try {
			await signInWithEmailLink(auth, email, window.location.href)
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error)

			if (error instanceof FirebaseError) {
				if (error.code === AuthErrorCodes.INVALID_OOB_CODE) {
					return {
						error: {
							code: error.code,
							message:
								'The email provided does not match the sign-in email address.'
						}
					}
				}

				if (error.code === AuthErrorCodes.INVALID_EMAIL) {
					return {
						error: {
							code: error.code,
							message:
								'The email provided does not match the sign-in email address.'
						}
					}
				}
			}
		} finally {
			// Clear email from storage.
			window.localStorage.removeItem(SIGN_IN_WITH_EMAIL_LOCAL_KEY)
		}
	}
}
